import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"
import Mobile from "../../images/mobile.svg"
import Desktop from "../../images/desktop.svg"
import Restaurant from "../../images/restaurant.svg"
import HomePageStyle from "./home-page.module.scss"
import ScrollAnimation from "react-animate-on-scroll"

const Highlights = () => (
    <StaticQuery query={graphql`
            query HomepageHighlights {
                contentfulFsdHompage{
                    homepageReference{
                      sectionContent1{
                        subtitle{
                          subtitle
                        }
                        sectionParagraph{
                          json
                        }
                      }
                      sectionContent2{
                        sectionParagraph{
                          json
                        }
                      }
                      sectionContent3{
                        sectionParagraph{
                          json
                        }
                      }
                      sectionContent4{
                        sectionParagraph{
                          json
                        }
                      }
                    }
                  }
                }
            `}
        render = {data => (
        <div className={HomePageStyle.sectionDiv}>

        {/* Web Features Mobile Links */}
         <Row className={HomePageStyle.section1Features} id="parent-div">
            <Col xs={12}><h3 className={HomePageStyle.sectionTitle}>Website Features</h3></Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={HomePageStyle.featuresBtn1} to="/essentials">The Essentials</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={HomePageStyle.featuresBtn2} to="/mobile-first">Mobile First</Link>
                </ScrollAnimation>    
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={HomePageStyle.featuresBtn3} to="/engaging-menu">Engaging Menu</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                 <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={HomePageStyle.featuresBtn4} to="/convenient-booking">Convenient Booking</Link>
                </ScrollAnimation>
                </div>
            </Col>
        </Row>

        {/* Section1 Intro Paragraph*/}
        <Row className={HomePageStyle.section1Highlights}>
            <Col xs={12}><h3 className={HomePageStyle.sectionTitle}>{data.contentfulFsdHompage.homepageReference.sectionContent1.subtitle.subtitle}</h3></Col>
            <Col xs={12}>
                <div className={HomePageStyle.sectionDescription}>
                {documentToReactComponents(data.contentfulFsdHompage.homepageReference.sectionContent1.sectionParagraph.json)}
                </div>
            </Col>
            <Col lg={4} className={HomePageStyle.highlightIconCol}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <Mobile className={HomePageStyle.highlightIcons} />
                </ScrollAnimation>
                {/* Section2 Highlight1 */}
                {documentToReactComponents(data.contentfulFsdHompage.homepageReference.sectionContent2.sectionParagraph.json)}
            </Col>
            <Col lg={4} className={HomePageStyle.highlightIconCol}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <Desktop className={HomePageStyle.highlightIcons} />
                </ScrollAnimation>
                 {/* Section3 Highlight2 */}
                 {documentToReactComponents(data.contentfulFsdHompage.homepageReference.sectionContent3.sectionParagraph.json)}
            </Col>
            <Col lg={4} className={HomePageStyle.highlightIconCol}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <Restaurant className={HomePageStyle.highlightIcons} />
                </ScrollAnimation>
                {/* Section1 Highlight3 */}
                {documentToReactComponents(data.contentfulFsdHompage.homepageReference.sectionContent4.sectionParagraph.json)}
            </Col>
        </Row>
    </div>
    )}
    />
)

export default Highlights